<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('diagnosis-information-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator" @click="OpenReport()">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>
            </div>
            <!-- DiagnosisInformation -->
            <div class="text-xs-right">
                <v-btn v-can:add :to="{ name: 'add-diagnosis-information' }" color="success">
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-diagnosis-information') }}
                </v-btn>
                <v-menu v-if="selected.length" bottom left origin="center center" transition="scale-transition" min-width="100">
                    <v-btn icon flat slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteDiagnosisInformation" v-can:delete>
                            <v-list-tile-title>{{ $t('delete') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postDiagnosisInformation" v-can:post>
                            <v-list-tile-title>{{ $t('post') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostDiagnosisInformation" v-can:unpost>
                            <v-list-tile-title>{{ $t('unpost') }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Search box -->
        <v-flex xs12>
            <v-card class="pa-3 mb-3">
                <v-layout wrap>
                    <!--<v-flex xs12>
        <v-text-field v-model="keyword"
                      append-icon="mdi-magnify"
                      :label="$t('search')"
                      single-line
                      hide-details
                      @change="getDiagnosisInformations"></v-text-field>
    </v-flex>-->
                    <v-flex md2 sm6 xs12 px-2>
                        <v-text-field :label="$t('national-number')" v-model="beneficiaryNationalNumJOR"
                                      @change="getDiagnosisInformations"></v-text-field>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('hand-diagnosis')"
                                        :error-messages="errors.collect(formScope + '.handDigonsis')"
                                        :item-text="getLabelByLang('enName', 'arName')"
                                        :items="handDigonsisList"
                                        :label="$t('hand-diagnosis')"
                                        clearable
                                        item-value="id"
                                        name="handDigonsis"
                                        v-model="handDigonsis"
                                        @change="getDiagnosisInformations"></v-autocomplete>
                    </v-flex>

                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('disability-type')"
                                        :error-messages="errors.collect(formScope + '.typeOfDisability')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="disabilityNaturesList"
                                        :label="$t('disability-type')"
                                        clearable
                                        item-value="code"
                                        name="typeOfDisability"
                                        v-model="typeOfDisability"
                                        @change="getDiagnosisInformations(), getDiseases($event)"></v-autocomplete>
                    </v-flex>

                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('disabilities-diagnosis')"
                                        :error-messages="errors.collect(formScope + '.definitionOfDiseasesId')"
                                        :item-text="getLabelByLang('arName', 'arName')"
                                        :items="diseasesList"
                                        :label="$t('disabilities-diagnosis')"
                                        clearable
                                        item-value="id"
                                        name="definitionOfDiseasesId"
                                        v-model="definitionOfDiseasesId"
                                        @change="getDiagnosisInformations"></v-autocomplete>
                    </v-flex>

                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="fromDiagonisisDateMenu">
                            <v-text-field :data-vv-as="$t('from-diagnosis-date')"
                                          :label="$t('from-diagnosis-date')"
                                          clearable
                                          name="fromDiagonisisDateMenu"
                                          prepend-icon="event"
                                          slot="activator"
                                          v-model="fromDiagonisisDate"></v-text-field>
                            <v-date-picker @change="fromDiagonisisDateMenu = false"
                                           min="1900-01-01"
                                           ref="picker"
                                           v-model="fromDiagonisisDate"></v-date-picker>
                        </v-menu>
                    </v-flex>

                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="toDiagonisisDateMenu">
                            <v-text-field :data-vv-as="$t('to-diagnosis-date')"
                                          :label="$t('to-diagnosis-date')"
                                          clearable
                                          name="toDiagonisisDateMenu"
                                          prepend-icon="event"
                                          slot="activator"
                                          v-model="toDiagonisisDate"></v-text-field>
                            <v-date-picker @change="toDiagonisisDateMenu = false"
                                           min="1900-01-01"
                                           ref="picker"
                                           v-model="toDiagonisisDate"></v-date-picker>
                        </v-menu>
                    </v-flex>

                    <!--<v-flex md3 px-2 sm6 xs12>
        <v-autocomplete :data-vv-as="$t('disability-degree')"
                        :error-messages="errors.collect(formScope + '.degreeOfDisability')"
                        :item-text="getLabelByLang('name', 'name')"
                        :items="disabilityDegreesList"
                        :label="$t('disability-degree')"
                        clearable
                        item-value="code"
                        name="degreeOfDisability"
                        v-model="degreeOfDisability"></v-autocomplete>
    </v-flex>
    <v-flex md3 px-2 sm6 xs12>
        <v-autocomplete :data-vv-as="$t('disability-nature')"
                        :error-messages="errors.collect(formScope + '.natureOfDisability')"
                        :item-text="getLabelByLang('name', 'name')"
                        :items="disabilityTypeList"
                        :label="$t('disability-nature')"
                        clearable
                        item-value="code"
                        name="natureOfDisability"
                        v-model="natureOfDisability"></v-autocomplete>
    </v-flex>
    <v-flex md3 px-2 sm6 xs12>
        <v-autocomplete :data-vv-as="$t('governorate')"
                        :error-messages="errors.collect(formScope + '.governoratecity')"
                        :item-text="getLabelByLang('name', 'name')"
                        :items="governoratesList"
                        :label="$t('governorate')"
                        clearable
                        item-value="code"
                        name="governoratecity"
                        v-model="governorate"></v-autocomplete>
    </v-flex>-->
                    <v-flex md2 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('select-gender')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="gendersList"
                                        :label="$t('select-gender')"
                                        :name="'gender'"
                                        clearable
                                        item-value="code"
                                        v-model="gender"></v-autocomplete>
                    </v-flex>
                    <!--<v-flex md3 px-2 sm6 xs12>
        <v-autocomplete :label="$t('Aging')"
                        :item-text="getLabelByLang('name', 'name')"
                        :name="'Aging'"
                        :items="AgingList"
                        clearable
                        item-value="code"
                        v-model="aging"></v-autocomplete>
    </v-flex>-->
                    <v-text-field :data-vv-as="$t('fileno')"
                                  :label="$t('fileno')"
                                  name="fileno"
                                  v-model="fileNo"
                                  v-validate="'max:50'"></v-text-field>

                    <v-checkbox :data-vv-as="$t('is-disability-approve')" 
                                :error-messages="errors.collect(formScope + '.isDisability')"
                                :label="$t('is-disability-approve')" 
                                name="isapprove"
                                v-model="isapprove"></v-checkbox>

                    <v-flex xs12>
                        <v-btn color="primary" type="submit" @click="getDiagnosisInformations()">{{ $t('filter') }}</v-btn>
                        <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                        <v-btn color="primary" @click="OpenReport2()">{{ $t('diagnosis-information-ReportStstistic') }}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          :loading="isLoading"
                          :headers="headers"
                          :items="diagnosisInformation"
                          v-model="selected"
                          select-all
                          class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.createdat | date }}</td>
                        <td>{{ props.item.fullName }}</td>
                        <td>{{ props.item.beneficiaryNationalNumJOR }}</td>
                        <td>{{ props.item.handDiagnosisName }}</td>
                        <td>{{ props.item.diagonisisDate | date }}</td>

                        <!--<td>{{ props.item.reDiagonisisDate | date }}</td>-->
                        <td>
                            <v-btn icon
                                   v-can:edit
                                   :to="{
                  name: 'edit-diagnosis-information',
                  params: { beneficiaryInformationId: props.item.beneficiaryInfoId, id: props.item.id }
                }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <td>
                            <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
                            <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <v-btn color="primary" type="reset" @click="deleteDiagnosisInformation()">{{ $t('delete') }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import LookUpService from '@/services/LookUpService';
    import DiagnosisInformationService from '@/services/Disabilities/PersonWithDisabilities/DiagnosisInformation/DiagnosisInformationService';
    import BranchService from '@/services/AdminSystem/OrganizationStructure/BranchService';
    import DefinitionOfDiseasesService from '@/services/Disabilities/PersonWithDisabilities/DefinitionOfDiseasesService';
    import SettingOrgService from "@/services/AdminSystem/OrganizationStructure/SettingOrgService";

    export default {
        name: 'diagnosis-information',
        data() {
            return {
                diagnosisInformation: [],
                selected: [],
                keyword: '',
                beneficiaryNationalNumJOR: '0',
                typeOfDisability: 0,
                definitionOfDiseasesId: 0,
                degreeOfDisability: 0,
                natureOfDisability: 0,
                isLoading: false,
                isapprove:false,
                handDigonsis: 0,
                governorate: 0,
                gender: 0,
                fileNo:'',
                aging: 0,
                handDigonsisList: [],
                gendersList: [],
                disabilityNaturesList: [],
                AgingList: [],
                governoratesList: [],
                diseasesList: [],
                disabilityDegreesList: [],
                disabilityTypeList: [],
                fromDiagonisisDateMenu: false,
                toDiagonisisDateMenu: false,
                fromDiagonisisDate: null,
                toDiagonisisDate:null
            }; 
        },
        async created() {
            this.getHandDigonsises();
            await this.getDiagnosisInformations();
            await this.getDisabilityNatures();
            await this.getDiseases();
            await this.getDisabilityDegrees();
            await this.getDisabilityTypes();
            await this.getGovernorates();
            await this.getGenders();
            await this.getAgingList();
        },
        methods: {
            async  filterInit() {
                this.beneficiaryNationalNumJOR = '';
                this.keyword = '';
                this.handDigonsis = 0;
                this.typeOfDisability = 0;
                this.definitionOfDiseasesId = 0;
                this.degreeOfDisability = 0;
                this.natureOfDisability = 0;
                this.governorate = 0;
                this.gender = 0;
                this.aging = 0;
                this.fileNo = '';
                await this.getDiagnosisInformations();
            },
            async getDiagnosisInformations() {
                this.diagnosisInformation = [];
                this.isLoading = true;
                var diagnosisInformation = (await DiagnosisInformationService.getDiagnosisInformations({
                    keyword: this.keyword,
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR,
                    handDigonsis: this.handDigonsis,
                    typeOfDisability: this.typeOfDisability,
                    definitionOfDiseasesId: this.definitionOfDiseasesId,
                    gender: this.gender,
                    fileNo: this.fileNo,
                })).data;
                
                this.diagnosisInformation = diagnosisInformation.filter(item => item.isapprove === this.isapprove);
                this.isLoading = false;
            },
            deleteDiagnosisInformation() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete users */
                    this.$store.dispatch('showLoading');
                    const result = await DiagnosisInformationService.deleteDiagnosisInformation(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        var firstIndexOf = result.data.message.indexOf('(') + 1;
                        var lastIndexOf = result.data.message.indexOf(')');
                        var gropsNames = result.data.message.substring(firstIndexOf, lastIndexOf);
                        var arrayNames = gropsNames.split(',');
                        var displayString = `${this.$t('delete')} ${arrayNames.length} ${this.$t('diagnosisInformation_s')}`;
                        //arrayNames.forEach((diagnosisInformation, index) => {
                        //    displayString += `\n ${index + 1} - ${diagnosisInformation}`;
                        //});
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            multiLine: true
                        });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    await this.getDiagnosisInformations();
                });
            },
            async postDiagnosisInformation() {
                let postDiagnosisInformations = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postDiagnosisInformations.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await DiagnosisInformationService.postDiagnosisInformation(postDiagnosisInformations);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getDiagnosisInformations();
            },
            async unpostDiagnosisInformation() {
                let postDiagnosisInformations = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postDiagnosisInformations.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await DiagnosisInformationService.postDiagnosisInformation(postDiagnosisInformations);
                this.selected = [];
                if (result.data.statusCode === 200) {
                   this.$store.dispatch('showMessage', {
                        text: result.data.message
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getDiagnosisInformations();
            },
            async OpenReport() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                var handDigonsis = this.handDigonsis;
                var typeOfDisability = this.typeOfDisability;
                var definitionOfDiseasesId = this.definitionOfDiseasesId;
                var degreeOfDisability = this.degreeOfDisability;
                var beneficiaryNationalNumJOR = this.beneficiaryNationalNumJOR;
                var natureOfDisability = this.natureOfDisability;
                var governorate = this.governorate;
                var gender = this.gender;
                var aging = this.aging;

                if (this.governorate == '' || this.governorate == null) {
                    governorate = "0";
                }

                if (this.gender == '' || this.gender == null) {
                    gender = "0";
                }

                if (this.aging == '' || this.aging == null) {
                    aging = "0";
                }

                if (this.handDigonsis == '' || this.handDigonsis == null) {
                    handDigonsis = "0";
                }

                if (this.beneficiaryNationalNumJOR == '' || this.beneficiaryNationalNumJOR == null) {
                    beneficiaryNationalNumJOR = "0";
                }

                if (this.typeOfDisability == '' || this.typeOfDisability == null) {
                    typeOfDisability = "0";
                }

                if (this.definitionOfDiseasesId == '' || this.definitionOfDiseasesId == null) {
                    definitionOfDiseasesId = "0";
                }

                if (this.degreeOfDisability == '' || this.degreeOfDisability == null) {
                    degreeOfDisability = "0";
                }

                if (this.natureOfDisability == '' || this.natureOfDisability == null) {
                    natureOfDisability = "0";
                }

                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/DiagonisisInfo.aspx?handDigonsis=' + handDigonsis
                        + '&typeOfDisability=' + typeOfDisability
                        + '&definitionOfDiseasesId=' + definitionOfDiseasesId
                        + '&degreeOfDisability=' + degreeOfDisability
                        + '&beneficiaryNationalNumJOR=' + beneficiaryNationalNumJOR
                        + '&aging=' + aging
                        + '&gender=' + gender
                        + '&NATUREOFDISABILITYCODE=' + natureOfDisability
                        + '&governorate=' + governorate
                        , '_blank');
                }
            },
            async OpenReport2() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;  

                if (this.fromDiagonisisDate === null) {
                    this.fromDiagonisisDate = '1-1-2020';
                }
                if (this.toDiagonisisDate === null) {
                    this.toDiagonisisDate = '1-1-2050';
                }
                if (settingOrg) { 
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/DiagonisisStatisticInfo.aspx?type=' + this.typeOfDisability
                        + '&fromdate=' + this.fromDiagonisisDate
                        + '&todate=' + this.toDiagonisisDate
                        , '_blank');
                }
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getGenders() {
                this.gendersList = (await LookUpService.getLookup(59)).data;
            },
            async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            async getDiseases(code) {
                if (code > 0) {
                    this.diseasesList = (await DefinitionOfDiseasesService.getDefinitionOfDiseasesByCriteria({
                        keyword: '',
                        typeOfDisability: code,
                    })).data;
                }
                else {
                    this.diseasesList = (await DefinitionOfDiseasesService.getDefinitionOfDiseasesByCriteria()).data;
                }
            },
            async getDisabilityTypes() {
                this.disabilityTypeList = (await LookUpService.getLookup(53)).data;
            },
            async   getAgingList() {
                this.AgingList.push(
                    {
                        code: 1,
                        name: 'الاطفال'
                    },
                    {
                        code: 2,
                        name: 'سن المدرسه'
                    },
                    {
                        code: 3,
                        name: 'سن العمل'
                    }
                    ,
                    {
                        code: 4,
                        name: 'فوق سن العمل'
                    }
                );
            },
            async getHandDigonsises() {
                this.$store.dispatch('showLoading');
                this.handDigonsisList = (await BranchService.getBranches()).data;
                this.$store.dispatch('hideLoading');
            },
            async getDisabilityDegrees() {
                this.disabilityDegreesList = (await LookUpService.getLookup(120)).data;
            },
        },
        computed: {
            selectedIds() {
                return this.selected.map(diagnosisInformation => ({
                    id: diagnosisInformation.id
                }));
            },

            headers() {
                return [
                       { text: this.$t('request-date'), value: 'createdat', sortable: false },
                    {
                        text: this.$t('beneficiary-name'),
                        value: 'fullName',
                        sortable: false
                    },
                    {
                        text: this.$t('beneficiary-nationalNumJOR'),
                        value: 'beneficiaryNationalNumJOR',
                        sortable: false
                    },
                    {
                        text: this.$t('hand-diagnosis'),
                        value: 'handDiagnosisName',
                        sortable: false
                    },
                    {
                        text: this.$t('diagnosis-date'),
                        value: 'diagonisisDate',
                        sortable: false
                    },
                    //{
                    //    text: this.$t('rediagnosis-date'),
                    //    value: 'reDiagonisisDate',
                    //    sortable: false
                    //},
                    { text: this.$t('edit'), value: '', sortable: false },
                    { text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            }
        }
    };
</script> 